// enum for caseStatus
// 1: New Inquiries (Unassigned)
// 10: New Inquiries (Assigned)
// 17: Waiting for records/family response
// 11: Under review by MD
// 12: Pending family approval
// 13: Finance review
// 14: Scheduling
// 15: Pending arrival
// 16: Arrived
// 9: Closed
export const STATUS_UNKNOWN = 0;
export const STATUS_NEW_UNASSIGNED = 1;
export const STATUS_NEW_ASSIGNED = 10;
export const STATUS_WAIT_FOR_RECORDS = 17;
export const STATUS_UNDER_REVIEW_BY_MD = 11;
export const STATUS_PENDING_FAMILY_APPROVAL = 12;
export const STATUS_FINANCE_REVIEW = 13;
export const STATUS_SCHEDULING = 14;
export const STATUS_PENDING_ARRIVAL = 15;
export const STATUS_ARRIVED = 16;
export const STATUS_CLOSED = 9;
export const STATUS_DUPLICATE = 18;

export const STATUS = [
  { key: STATUS_UNKNOWN, value: 'Undefined', text: 'Undefined' },
  {
    key: STATUS_NEW_UNASSIGNED,
    value: 'New Inquiries (Unassigned)',
    text: 'New Inquiries(Unassigned)'
  },
  {
    key: STATUS_NEW_ASSIGNED,
    value: 'New Inquiries (Assigned)',
    text: 'New Inquiries(Assigned)'
  },
  {
    key: STATUS_WAIT_FOR_RECORDS,
    value: 'Waiting for records/family response',
    text: 'Waiting for records or family response'
  },
  {
    key: STATUS_UNDER_REVIEW_BY_MD,
    value: 'Under review by MD',
    text: 'Under review by MD'
  },
  {
    key: STATUS_PENDING_FAMILY_APPROVAL,
    value: 'Pending family approval',
    text: 'Pending family approval'
  },
  { key: STATUS_FINANCE_REVIEW, value: 'Finance review', text: 'Finance review' },
  { key: STATUS_SCHEDULING, value: 'Scheduling', text: 'Scheduling' },
  {
    key: STATUS_PENDING_ARRIVAL,
    value: 'Pending arrival',
    text: 'Pending arrival'
  },
  { key: STATUS_ARRIVED, value: 'Arrived', text: 'Arrived' },
  { key: STATUS_CLOSED, value: 'Closed', text: 'Closed' },
  { key: STATUS_DUPLICATE, value: 'Duplicate or Invalid', text: 'Duplicate or Invalid' }
];

export const getText = (key) => {
  if (key === undefined) return '';

  var text = STATUS.find((obj) => {
    return obj.key === key;
  }).text;
  return text;
};

export const STATUS_MESSAGES = [
  { key: STATUS_UNKNOWN, text: 'Undefined' },
  {
    key: STATUS_NEW_UNASSIGNED,
    text: 'Thank you for submitting your inquiry. A case coordinator will be assigned, review your request, and follow up soon.'
  },
  {
    key: STATUS_NEW_ASSIGNED,
    text: 'Your inquiry has been assigned to a case coordinator and is under review. After their review of you inquiry they will follow up with you soon. They will also keep you updated throughout the process and answer any questions you may have. If you have any questions, please contact your case coordinator at {0} or {1}'
  },
  {
    key: STATUS_WAIT_FOR_RECORDS,
    text: "Your care team is waiting on additional information from you. Please respond to your case coordinator's email requests or contact your coordinator at {0} or {1} if you have any questions."
  },
  {
    key: STATUS_UNDER_REVIEW_BY_MD,
    text: 'A Heart Center physician is currently reviewing your medical history and looking to address your questions. \nYour case coordinator or physician will respond shortly. If you have any questions, please free to contact your case coordinator at {0} or {1}'
  },
  {
    key: STATUS_PENDING_FAMILY_APPROVAL,
    text: "Our care team has has delivered you the recommendations from our expert Heart Center physician and now await a response from you on how you would like to proceed. Please respond to your case coordinator's email requests or if you have any questions, contact them at {0} or {1}."
  },
  {
    key: STATUS_FINANCE_REVIEW,
    text: "Our care team is reviewing your case for the next steps.  We will be in contact with you shortly. Please respond to your case coordinator's email requests or if you have any questions, contact them direct at {0} or {1}"
  },
  {
    key: STATUS_SCHEDULING,
    text: 'We look forward to your arrival.  Your care team will contact you to schedule your visit and arrival. If you have any questions, please contact your case coordinator at {0} or {1}'
  },
  {
    key: STATUS_PENDING_ARRIVAL,
    text: "Your appointment to the Boston Children's Heart Center has been scheduled. We look forward to your arrival. If you have any questions, please contact your case coordinator at {0} or {1}"
  },
  {
    key: STATUS_ARRIVED,
    text: "Thank you for choosing the Heart Center at Boston Children's Hospital"
  },
  {
    key: STATUS_CLOSED,
    text: 'Your case is now closed.  If you have any further questions feel free to contact your case coordinator at {0} or {1}'
  },
  {
    key: STATUS_DUPLICATE,
    text: 'Your case is now closed.  If you have any further questions feel free to contact your case coordinator at {0} or {1}'
  }
];

export const getMessages = (key, tel, email) => {
  if (tel === undefined) tel = '1-844-354-2160';
  if (email === undefined) email = 'Heart@childrens.harvard.edu';

  var text = STATUS_MESSAGES.find((obj) => {
    return obj.key === key;
  }).text;
  if (tel !== null && email !== null) {
    return text.replace('{' + 0 + '}', tel).replace('{' + 1 + '}', email);
  } else {
    return text;
  }
};
